import { render, staticRenderFns } from "./categorie_article_list.vue?vue&type=template&id=3127dd8f&"
import script from "./categorie_article_list.vue?vue&type=script&lang=js&"
export * from "./categorie_article_list.vue?vue&type=script&lang=js&"
import style0 from "./categorie_article_list.vue?vue&type=style&index=0&id=3127dd8f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports